import { ReportConstrucorService } from "connection/report-constructor-service";
import TemplateList from "assets/filter-list/template_list";
import { checkErrorMessage, getErrorMessage } from "./errors";

const SET_REPORT_CONSTRUCTOR_TEMPLATES = "SET-REPORT-CONSTRUCTOR-TEMPLATES";
const SET_SELECTED_REPORT_TEMPLATE = "SET-SELECTED-REPORT-TEMPLATE";
const SET_IS_REPORTS_UPDATED = "SET-IS-REPORTS_UPDATED";
const SET_IS_READ_ONLY = "SET-IS-READ-ONLY";
const SET_CREATED_STATUS = "SET-CREATED-STATUS";
const SET_REPORT_CONSTRUCTOR_ERROR_MESSAGE = "SET-REPORT-CONSTRUCTOR-ERROR-MESSAGE";
const SET_REPORT_CONSTRUCTOR_CURRENT_PAGE = "SET_REPORT_CONSTRUCTOR_CURRENT_PAGE";

const STATUS = TemplateList.STATUS;

const DEFAULT_FONT_PARAMETERS = TemplateList.DEFAULT_FONT_PARAMETERS;

const DEFAULT_ANALYTICS_PARAMETERS = TemplateList.DEFAULT_ANALYTICS_PARAMETERS;

const DOCUMENT_ELEMENTS = TemplateList.DOCUMENT_ELEMENTS;

const FONTS_LIST = TemplateList.FONTS_LIST;

const TEXT_REPRESENTATION_LIST = TemplateList.TEXT_REPRESENTATION_LIST;

const GROUPING_TYPE_LIST = TemplateList.GROUPING_TYPE_LIST;

const FIELDS_LIST = TemplateList.FIELDS_LIST;

const COLORS_LIST = TemplateList.COLORS_LIST;

const INCLUDE_TOC_LIST = TemplateList.INCLUDE_TOC_LIST;

const DATE_FIELDS = TemplateList.DATE_FIELDS;

const FEED_SETTINGS = TemplateList.FEED_SETTINGS;

const reportConstructorData = {
    reportTemplates: null,
    controlButtons: ["edit", "show", "copy", "delete"],
    textRepresentationList: TEXT_REPRESENTATION_LIST,
    groupingTypeList: GROUPING_TYPE_LIST,
    includeTocList: INCLUDE_TOC_LIST,
    dateFields: DATE_FIELDS,
    reportComponents:{
        TEXT:{
            parameters:{
                TEXT: "",
                ALIGNMENT: "LEFT"
            },
            type: 'TEXT'
        },
        TOPIC_NAME: {
            parameters: {
                ALIGNMENT: 'LEFT'
            },
            type: 'TOPIC_NAME'
        },
        DATE_RANGE: {
            parameters: {
                ALIGNMENT: 'LEFT'
            },
            type: 'DATE_RANGE'
        },
        DOCUMENT_NUMFOUND: {
            parameters: {
                ALIGNMENT: 'LEFT'
            },
            type: 'DOCUMENT_NUMFOUND'
        },
        FEED: {
            parameters: {
                DOCUMENT_ELEMENTS: DOCUMENT_ELEMENTS,
                FEED_SETTINGS: {
                    linkElements: ["DOCUMENT_TITLE", "DOCUMENT_DOMAIN", "DOCUMENT_DATE"],
                    documentGap: true,
                    documentTitle: ["DOMAIN", "TITLE"],
                    icons: true
                },
                TEXT_REPRESENTATION: 'HIGHLIGHTED_FULL_TEXT',
                GROUPING_TYPE: 'NO_GROUPING',
                INCLUDE_TOC: true,
                
            },
            type: 'FEED'
        },
        PAGE_BREAK: {
            parameters: {

            },
            type: 'PAGE_BREAK'
        },
        VERTICAL_GAP: {
            parameters:{
                GAP_LINES: 1
            },
            type: 'VERTICAL_GAP'
        },
        IMAGE: {
            parameters: {
                IMAGE_BASE64: '',
                IMAGE_FORMAT: '',
                ALIGNMENT: 'LEFT'
            },
            type: "IMAGE"
        },
        TABLE: {
            parameters: {
                ALIGNMENT: 'LEFT',
                ANALYTICS_PARAMETERS: DEFAULT_ANALYTICS_PARAMETERS
            },
            type: 'TABLE'
        },
        PIE_CHART: {
            parameters:{
                TITLE: "",
                ALIGNMENT: 'LEFT',
                ANALYTICS_PARAMETERS: {
                    fields: ["sentiment"],
                    limit: 20,
                    minCount: 1,
                    missing: true
                }
            },
            type: 'PIE_CHART'
        },
        BAR_CHART: {
            parameters:{
                TITLE: "",
                ALIGNMENT: 'LEFT',
                ANALYTICS_PARAMETERS: DEFAULT_ANALYTICS_PARAMETERS
            },
            type: 'BAR_CHART'
        },
        LINE_CHART: {
            parameters:{
                ALIGNMENT: 'LEFT',
                TITLE: "",
                ANALYTICS_PARAMETERS: DEFAULT_ANALYTICS_PARAMETERS
            },
            type: 'LINE_CHART'
        },
        LOGO: {
            type: 'LOGO',
            parameters: {
                ALIGNMENT: "RIGHT"
            }
        }
    },
    fonts: FONTS_LIST,
    colors: COLORS_LIST,
    fields: FIELDS_LIST,
    reportParameters: {
        FONT_PARAMETERS: DEFAULT_FONT_PARAMETERS
    },
    documentElementsList: DOCUMENT_ELEMENTS,
    selectedReportTemplate: null,
    isReportsUpdated: false,
    isReadOnly: true,
    createdStatus: null,
    reportConstructorErrorEmssage: null,
    totalElements: null,
    currentPage: 0,
    feedSettings: FEED_SETTINGS
}

const ReportConstructor = (state = reportConstructorData, action) => {
    switch(action.type){
        case SET_REPORT_CONSTRUCTOR_TEMPLATES:
            let count = action.reportTemplates && action.reportTemplates.totalElements ? action.reportTemplates.totalElements : null 
            return {...state, reportTemplates: action.reportTemplates, totalElements: count}
        case SET_SELECTED_REPORT_TEMPLATE:
            return {...state, selectedReportTemplate: action.reportTemplate} 
        case SET_IS_REPORTS_UPDATED:
            return {...state, isReportsUpdated: action.isReportsUpdated}
        case SET_IS_READ_ONLY:
            return {...state, isReadOnly: action.isReadOnly}
        case SET_CREATED_STATUS:
            return {...state, createdStatus: action.createdStatus}
        case SET_REPORT_CONSTRUCTOR_ERROR_MESSAGE:
            return {...state, reportConstructorErrorEmssage: errorMessage}
        case SET_REPORT_CONSTRUCTOR_CURRENT_PAGE:
            return {...state, currentPage: action.currentPage}
        default:
            return {...state}
    }
}

export default ReportConstructor;

export const setCurrentPage = (currentPage) => {
    return {
        type: SET_REPORT_CONSTRUCTOR_CURRENT_PAGE,
        currentPage: currentPage
    }
}

export const setCreateStatus = (status) => {
    return {
        type: SET_CREATED_STATUS,
        createdStatus: status
    }
}

export const setIsReadOnly = (isReadOnly) => {
    return {
        type: SET_IS_READ_ONLY,
        isReadOnly: isReadOnly
    }
}

export const setIsReportUpdated = (isReportsUpdated) => {
    return {
        type: SET_IS_REPORTS_UPDATED,
        isReportsUpdated: isReportsUpdated
    }
}

export const setSelectedReportTemplate = (reportTemplate) => {
    return {
        type: SET_SELECTED_REPORT_TEMPLATE,
        reportTemplate: reportTemplate
    }
}

const setReportConstructorTemplates = (reportTemplates) => {
    return {
        type: SET_REPORT_CONSTRUCTOR_TEMPLATES,
        reportTemplates: reportTemplates
    }
}

export const getReportConstructorTemplates = (currentPage, showedItemsCount) => {
    return (dispatch) => {
        ReportConstrucorService.getReportTemplates(currentPage, showedItemsCount).then(data=>{
            dispatch(setReportConstructorTemplates(data));
            dispatch(setIsReportUpdated(true));
        }).catch(error => {
            dispatch(checkErrorMessage({code: error.response.status, message: getErrorMessage(error)}))
        });
    }
}

export const getReportTemplateById = (templateId) => {
    return (dispatch) => {
        ReportConstrucorService.getReportTemplate(templateId).then(data=>{
            dispatch(setReportConstructorTemplates(data));
            dispatch(setIsReportUpdated(true));
        }).catch(error => {
            dispatch(checkErrorMessage({code: error.response.status, message: getErrorMessage(error)}))
        });
    }
}

export const copyTemplate = (template, title, currentPage, showedItemsCount) => {
    return (dispatch) => {
        ReportConstrucorService.createReportConstructorTemplate(title, template.parameters).then(data => {
            dispatch(updateReportConstructorTemplateComponents(data.id, template.components, currentPage, showedItemsCount))
            dispatch(setCreateStatus(STATUS.SUCCESS));
        }).catch(error => {
            dispatch(checkErrorMessage({code: error.response.status, message: getErrorMessage(error)}));
            dispatch(setCreateStatus(STATUS.FAILED));
        })
    }
}

export const createReportConstructorTemplate = (name, parameters, currentPage, showedItemsCount) => {
    return (dispatch) => {
        ReportConstrucorService.createReportConstructorTemplate(name, parameters).then(data => {
            dispatch(getReportConstructorTemplates(currentPage, showedItemsCount));
            dispatch(setCreateStatus(STATUS.SUCCESS));
        }).catch(error => {
            dispatch(checkErrorMessage({code: error.response.status, message: getErrorMessage(error)}));
            dispatch(setCreateStatus(STATUS.FAILED));
        })
    }
}

export const updateReportConstructor = (id, name, parameters) => {
    return (dispatch) => {
        ReportConstrucorService.updateReportConstructor(id, name, parameters).then(data => {
            dispatch(getReportConstructorTemplates());
            //dispatch(setCreateStatus(STATUS.SUCCESS));
        }).catch(error => {
            dispatch(checkErrorMessage({code: error.response.status, message: getErrorMessage(error)}));
            //dispatch(setCreateStatus(STATUS.FAILED));
        })
    }
}

export const updateReportConstructorTemplateComponents = (id, parameters, currentPage, showedItemsCount) => {
    return (dispatch) => {
        ReportConstrucorService.updateReportConstructorComponents(id, parameters).then( data => {
            dispatch(getReportConstructorTemplates(currentPage, showedItemsCount));
            
            dispatch(setCreateStatus(STATUS.SUCCESS));
            dispatch(setSelectedReportTemplate(null));
        }).catch(error => {
            dispatch(checkErrorMessage({code: error.response.status, message: getErrorMessage(error)}));
            dispatch(setCreateStatus(STATUS.FAILED));
        })
    }
}

export const deleteReportTemplate = (id, currentPage, showedItemsCount) => {
    return (dispatch) => {
        ReportConstrucorService.deleteReportTemplate(id).then(data => {
            dispatch(getReportConstructorTemplates(currentPage, showedItemsCount));
        })
    }
}